/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import './component012.less';

interface IComponent012Props {
  title: string;
  list: [];
  className?: string;
}

const component012: React.FunctionComponent<IComponent012Props> = ({
  title,
  list,
  className,
}) => (
  <div className={`component component012 ${className}`}>
    <div className="component012-left">
      <div className="component012-title">{title}</div>
    </div>
    <div className="component012-right">
      <ul>
        {list.map((itm: string) => (
          <li key={itm}>{itm}</li>
        ))}
      </ul>
    </div>
  </div>
);

export default component012;
